import _ from './card-ghost.styles.scss';

export default angular.module('directives.ghostCard', [])
  .directive('ghostCard', function () {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./card-ghost.template.html')
    }
  })
  .name;